<div class="panel">
  <button mat-icon-button class="close-button-custom" mat-dialog-close tabindex="-1">
    <mat-icon>close</mat-icon>
  </button>
 
  <h1 mat-dialog-title>
    {{title}}
  </h1>
  
  <div mat-dialog-content>
    <p>{{message}}</p>
  </div>
 
  <div mat-dialog-actions>
    <button class="m-r-15" mat-raised-button [color]="confirmColor || 'accent'" (click)="onConfirm()" cdkFocusInitial>
      {{ confirmText || 'Si' }}
    </button>
    <button mat-raised-button [color]="cancelColor || 'warn'" (click)="onDismiss()">
      {{ cancelText || 'No' }}
    </button>
  </div>
</div>
 